<template>
    <div class="inform-notice">
        <div class="icon">
            <slot name="icon"></slot>
        </div>
        <div class="text">
            <slot name="text"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InformNotice',
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.inform-notice {
    background: var(--overlay-background);
    border-radius: var(--input-border-radius);
    padding: 20px 60px 20px 20px;
    display: flex;
    align-items: center;
    gap: 8px;

    .icon {
        flex: none;
    }

    .text {
        flex: 1;
    }
}
</style>
